let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gpnLe")).then(() => parcelRequire('4siX9'));